import { CardHeaderProps } from 'shared/mui/Card';

import { CardHeaderStyled, CardStyled, CardContentStyled } from './DashboardCard.styled';

type Props = { cardHeaderProps: CardHeaderProps; children: React.ReactNode };

export const DashboardCard: React.FC<Props> = ({
  cardHeaderProps: { description, title, titleSize = 'xsmallBold', ...restProps },
  children,
}) => {
  return (
    <CardStyled>
      <CardHeaderStyled
        description={description}
        title={title}
        titleSize={titleSize}
        {...restProps}
      />
      <CardContentStyled>{children}</CardContentStyled>
    </CardStyled>
  );
};
